
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NotificationComponent} from './component/notification_components'
import {NotificationServices} from './services/notification_services'
import { HttpModule } from '@angular/http';
import {RouterModule, Routes} from '@angular/router';
const appRoutes: Routes = [
    {path: '', component: NotificationComponent}
  ];
@NgModule({
  declarations: [
    NotificationComponent
  ],
  imports: [
    BrowserModule,HttpModule,RouterModule.forRoot(appRoutes)
  ],
  providers:[NotificationServices],
  exports: [NotificationComponent]
})
export class NotifyModule { }
